<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                AP Invoice Adjustment - Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                            </b-input-group>
                        </b-col>   
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" ></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                          <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.nomor"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Destination Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.glAccount"  :state="!$v.model.kodeacc.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCoaShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.nilai" :precision="2" :state="!$v.model.nilai.$error"  :minus="true"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>   
              <label><strong>Detail Invoice Settlement</strong></label>
              <b-card no-body class="mt-0">
                    <b-table
                        class="mb-0"
                        ref="tblApadjudt"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="apadjudt.items"
                        :fields="apadjudt.fields"
                        :current-page="apadjudt.page"
                        :per-page="apadjudt.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>
                            <template v-slot:cell(nilaibayar)="data">
                            {{data.item.nilaibayar|numFormat}}
                            </template>
                            <template v-slot:cell(kurskeap)="data">
                            {{data.item.kurskeap|numFormat('0.000')}}
                            </template>
                            <template v-slot:cell(nilaibank)="data">
                            {{data.item.nilaibank|numFormat}}
                            </template>
                            <template v-slot:cell(selisihkurs)="data">
                            {{data.item.selisihkurs|numFormat('0,0.00')}}
                            </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editApadjudt(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delApadjudt(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                        <b-row align-h="around">
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>AP Invoice No.</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="apadjudtObj.invoice" @keyup.13.native="lkuApinvShow=true" :state="!$v.apadjudtObj.apinvkey.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuApinvShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                    <b-form-input v-model="apadjudtObj.uraian" disabled></b-form-input>
                                </b-input-group>
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Total Invoice</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{apadjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="apadjudtObj.totalinv" :precision="2" disabled></my-number>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="5">
                                        <b-input-group >
                                            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Outstanding</label></b-input-group-prepend>
                                            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Outstanding</span></b-input-group-prepend>
                                            <b-input-group-prepend class="d-md-block  d-lg-none"><span class="input-group-text" style="width:60px;">{{apadjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="apadjudtObj.outstand" :precision="2" disabled></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col lg="6">
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Setttled Original Amt.</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{apadjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="apadjudtObj.nilaibayar" :precision="2" :state="!$v.apadjudtObj.nilaibayar.$error" :minus="true" @change="calcNilaiAP"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Setttled LCY Amt.</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="apadjudtObj.nilaibank" :precision="2" :state="!$v.apadjudtObj.nilaibank.$error" :minus="true" @change="calcNilaiAP"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters v-if="(model.matauang != apadjudtObj.matauang)">
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Exch. Rate {{model.matauang}}</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{apadjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="apadjudtObj.kurskeap" :precision="6" :state="!$v.apadjudtObj.kurskeap.$error"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>                            
                            <b-row class="justify-content-center mb-2">
                                <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click="saveApadjudt()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click="addApadjudt" >Add Settlement</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(apadjudt.page - 1) * apadjudt.limit + 1}}
                          to
                          {{apadjudt.page * apadjudt.limit}}
                          of
                          {{apadjudt.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="apadjudt.total"
                          :per-page="apadjudt.limit"
                          v-model="apadjudt.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
              </b-card>    
            </b-form>
            <b-row >
                <b-col lg="7">
                    <div class="text-right">
                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                    </div>
                </b-col>
                <b-col lg="5">
                    <div class="text-right">
                    <b-input-group >
                        <b-input-group-prepend><label style="width:180px;">Total Detail Settlement</label></b-input-group-prepend>
                        <b-input-group-prepend>
                            <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                    </b-input-group>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuApinvShow" size="lg" :hide-footer="true" title="List of AP Invoice"  :centered="true">
            <lku-ap @click="onSelectLkuAp" :formdata="lkuApinvData"></lku-ap>
        </b-modal>      
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>    
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
.row-details-form {
    label {
    text-align: right !important;;
    }
    legend {
    text-align: right !important;;
    }

}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuAp from "../lookup/lkuApLazzy";
import lkuCoa from "../lookup/lkuCoa";
import dimension from "../../apis/dimension";
import apadjust from '../../apis/apadjust';
import { validationMixin } from "vuelidate";
import { required, minValue, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading,myNumber, vDim, lkuAp,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            kodeacc: { required },
            uraian: { required },
            tanggal: { required },
            matauang: { required },
            nilai: { required },
        },
        apadjudtObj :{
            apinvkey: { required },
            nilaibayar: { required },
            nilaibank: { required },
            kurskeap: { required, minValue:minValue(0.0000001) },  
        },
  }, 
  data() {
    return {
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
      isLoading:false,

        horizontal:true,
        model:{kurstrx:1, glAccount:''},
        lkuCoaShow: false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        apadjudt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "invoice",
                    thStyle: "width:150px",
                    label: "Invoice Number",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibayar",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeap",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Adjustment Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement in Deduction Amt.",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:80px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        apadjudtObj:{apinvkey:'', nilaibank:'', nilaibayar:''},
        lkuApinvShow: false,
        lkuApinvData: {},
        lkuCustomerShow:false,
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidApadjudt() {
      this.$v.apadjudtObj.$touch();
      return this.$v.apadjudtObj.$invalid;
    },
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      if (this.$route.params.apadjuttKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {
           const data = await apadjust.detail(this.$route.params);  
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.apadjudt.items = data[1];
            this.apadjudt.total=this.apadjudt.items.length;
            this.calcTotalDtlPaym();
            this.updateDimHdr = !this.updateDimHdr;
            // if (this.model.jenis==='Tunai'){
            //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            // } 
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    calcNilaiAP: function(){
        setTimeout(() => {
                if (this.apadjudtObj.matauang.trim() == this.model.matauang.trim()) {
                    this.apadjudtObj.nilaibank=this.apadjudtObj.nilaibayar;
                    this.apadjudtObj.kurskeap = 1;
                } else {
                    if ((this.apadjudtObj.kurskeap) && (this.apadjudtObj.nilaibayar)) {
                        this.apadjudtObj.nilaibank=this.apadjudtObj.nilaibayar*this.apadjudtObj.kurskeap;
                    }
                }            
        }, 500);
    },
    showLkuCoa(callerObj) {
        this.lkuCoaShow=true;
        this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.model.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;
        } else if (Math.abs(this.totalDtlPaym - parseFloat(this.model.nilai))>0.5) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
            this.isLoading=false;
        } else {
            this.model.TableName = 'aradjutt';
            try {
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.nomor = this.model.nomor || '';
                    this.model.nilai = this.model.nilai || 0;
                      this.model.matauang=this.uanguser;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    let newApadjudts = this.apadjudt.items.reduce((newArr, item) => {
                        if ((item.apinvkey || '') != '') {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

                    row.lines = newApadjudts;
                    this.isLoading=false;
                    const hasil= await apadjust.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save AP Invoice Adjustment",10000);
                    this.close();
                } else {
                    this.isLoading=false;
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                }

            } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }

        }
    },
    closeApadjudt: function(){
        const opened= this.apadjudt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },

    addApadjudt : function () {
        this.closeApadjudt();
        const obj={_showDetails:true};
        this.apadjudt.selected = obj;
        for (var key in this.apadjudtObj) {
            this.apadjudtObj[key] = '';
        }
        this.apadjudtObj.kurskeap=1;
        this.tabIndex = 0;
        this.apadjudt.items.push(obj);
        this.apadjudt.total=this.apadjudt.items.length;
        setTimeout(() => {
                const bfore = this.apadjudt.page;
                const after =Math.ceil((this.apadjudt.total)/this.apadjudt.limit);
                if (bfore != after){
                    this.apadjudt.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.apadjudt.total} items`,'Line/Detail',10000);
                }
        }, 100);    
    },
    editApadjudt : function (obj,callback) {
        this.closeApadjudt();
        this.apadjudt.selected = obj;
        for (var key in this.apadjudtObj) {
            this.apadjudtObj[key] = '';
        }
        for (var key in obj) {
            this.apadjudtObj[key] = obj[key];
        }
        setTimeout(() => {
            this.tabIndex = (this.adaNilaiBank) ? 0:1;            
        }, 200);
        callback();
    },
    delApadjudt: function (index) {
        if (index > -1) {
            // this.apadjudt.items.splice(index, 1);
            const posisi = (this.apadjudt.page-1)*this.apadjudt.limit;
            this.apadjudt.items.splice(posisi+index, 1);
        }
        this.apadjudt.total=this.apadjudt.items.length;
        this.calcTotalDtlPaym();
    },
    saveApadjudt: function (callback) {
        if (!this.adaPotongan) this.apadjudtObj.IDPotongan='';
        this.apadjudtObj.nilaibayar = this.apadjudtObj.nilaibayar || 0;
        this.apadjudtObj.kasdiskon = this.apadjudtObj.kasdiskon || 0;
                
        if (this.invalidApadjudt) {
            console.log('validation : ', this.$v.apadjudtObj);
            console.log('model obj : ',this.apadjudtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else if (this.apadjudtObj.nilaibayar>this.apadjudtObj.outstand){
            toastr.error('Receipt Amount exceeds Outstanding Amount', "ERROR MESSAGE");
       } else {
            let totInvSttl = this.apadjudt.items.reduce((tot, item) => {
                            if (item.apinvkey == this.apadjudtObj.apinvkey) {
                                tot + ((item.nilaibayar||0)+(item.kasdiskon||0));
                            }
                            return tot;
                        }, (this.apadjudtObj.nilaibayar + this.apadjudtObj.kasdiskon));
            if (this.apadjudt.selected.apinvkey == this.apadjudtObj.apinvkey)
                totInvSttl= totInvSttl -  ((this.apadjudt.selected.nilaibayar||0) + (this.apadjudt.selected.kasdiskon||0));

            // if ((this.apadjudtObj.nilaibayar + this.apadjudtObj.kasdiskon)>this.apadjudtObj.outstand){
            if (totInvSttl>this.apadjudtObj.outstand){
                toastr.error('Settled Amount exceeds Outstanding Amount', "ERROR MESSAGE");
            } else {
                this.apadjudtObj.selisihkurs = this.apadjudtObj.nilaibank - (this.apadjudtObj.nilaibayar * this.apadjudtObj.kurskeap);
                for (var key in this.apadjudtObj) {
                    this.apadjudt.selected[key] = this.apadjudtObj[key];
                }
                this.calcTotalDtlPaym();
                this.apadjudt.selected._showDetails=false;
                if (callback) callback();
            }

        }
    },
    onSelectLkuAp(invLookup) {
        this.apadjudtObj.apinvkey=invLookup.selected.apinvkey;
        this.apadjudtObj.nomor=invLookup.selected.nomor;
        this.apadjudtObj.invoice=invLookup.selected.invoice;
        this.apadjudtObj.uraian=invLookup.selected.uraian;
        this.apadjudtObj.vendor=invLookup.selected.vendor;
        this.apadjudtObj.vendorinfo=invLookup.selected.vendorinfo;
        this.model.terimadari=invLookup.selected.vendorinfo;
        this.apadjudtObj.matauang=invLookup.selected.matauang;
        this.apadjudtObj.totalinv=invLookup.selected.totalinv;
        this.apadjudtObj.outstand=invLookup.selected.outstand;
        this.apadjudtObj.nilaibayar=invLookup.selected.outstand;
        // this.apadjudtObj.nilaidpp=invLookup.selected.nilaidpp;
        // this.apadjudtObj.ttlpph=invLookup.selected.ttlpph;
        // this.apadjudtObj.pasalpph=invLookup.selected.pasalpph;
        this.updateDimDtl2Hdr(invLookup.selected);
        if (this.apadjudtObj.matauang.trim() == this.model.matauang.trim()) {
            this.apadjudtObj.nilaibank=invLookup.selected.outstand;
            this.apadjudtObj.kurskeap = 1;
            this.apadjudtObj.selisihkurs = 0;
        }
        this.lkuApinvShow=false;
        this.lkuApinvData=invLookup;
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.CustName = _selected.CustName;
        this.lkuCustomerShow=false;
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.apadjudt.items.forEach((trx)=> {
            if (trx.apinvkey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
      if ((this.$store.state.prevRoute.name)  && (this.$store.state.prevRoute.name=='payable.invadjustfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'payable.invadjust'});
      }
    }
  }
};
</script>
